export default __webpack_public_path__ + "static/media/bi_filter.65cc8d4c.svg";